"use client";

import { c as _c } from "react/compiler-runtime";
import { Card, CardContent } from "@/components/rac/card";
import { Avatar } from "@/components/radix/avatar";
import { cn } from "@/utils/cn";
import { Star, StarHalf } from "lucide-react";
import Image from "next/image";
import React from "react";
import { Testimonial } from ".";
interface TestimonialCardProps {
  testimonial: Testimonial;
  className?: string;
}
export const TestimonialCard: React.FC<TestimonialCardProps> = t0 => {
  const $ = _c(41);
  const {
    testimonial,
    className
  } = t0;
  let t1;
  if ($[0] !== testimonial.rating) {
    t1 = () => Array(5).fill(0).map((_, i) => {
      const isFilled = i < Math.floor(testimonial.rating);
      const isHalf = !isFilled && i < testimonial.rating;
      return <span key={i} className="inline-block" role="img" aria-hidden="true">{isFilled ? <Star className="w-4 h-4 fill-primary text-primary" /> : isHalf ? <StarHalf className="w-4 h-4 fill-primary text-primary" /> : <Star className="w-4 h-4 text-muted-foreground" />}</span>;
    });
    $[0] = testimonial.rating;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const renderStars = t1;
  let t2;
  if ($[2] !== className) {
    t2 = cn("bg-background shadow-sm h-80 border", className);
    $[2] = className;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== testimonial.avatar || $[5] !== testimonial.name) {
    t3 = testimonial.avatar ? <Image src={testimonial.avatar} alt={testimonial.name} width={40} height={40} className="object-cover w-full h-full" /> : testimonial.name.charAt(0);
    $[4] = testimonial.avatar;
    $[5] = testimonial.name;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <Avatar className="w-10 h-10" aria-hidden="true">{t3}</Avatar>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== testimonial.name) {
    t5 = <div className="font-medium text-sm text-foreground">{testimonial.name}</div>;
    $[9] = testimonial.name;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const t6 = `Rated ${testimonial.rating} out of 5 stars`;
  let t7;
  if ($[11] !== renderStars) {
    t7 = renderStars();
    $[11] = renderStars;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== testimonial.rating) {
    t8 = <span className="sr-only">{testimonial.rating} out of 5 stars</span>;
    $[13] = testimonial.rating;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t6 || $[16] !== t7 || $[17] !== t8) {
    t9 = <div role="img" aria-label={t6}>{t7}{t8}</div>;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== testimonial.timeAgo) {
    t10 = <span className="text-xs text-muted-foreground ml-1">{testimonial.timeAgo}</span>;
    $[19] = testimonial.timeAgo;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t10 || $[22] !== t9) {
    t11 = <div className="flex items-center gap-1">{t9}{t10}</div>;
    $[21] = t10;
    $[22] = t9;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t11 || $[25] !== t5) {
    t12 = <div>{t5}{t11}</div>;
    $[24] = t11;
    $[25] = t5;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== t12 || $[28] !== t4) {
    t13 = <div className="flex items-center gap-3 mb-3">{t4}{t12}</div>;
    $[27] = t12;
    $[28] = t4;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== testimonial.summary) {
    t14 = testimonial.summary && <div className="flex-grow mb-2"><p className="text-muted-foreground text-sm font-bold" aria-live="polite" tabIndex={0}>{testimonial.summary}</p></div>;
    $[30] = testimonial.summary;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== testimonial.review) {
    t15 = <div className="flex-grow overflow-hidden"><p className="text-muted-foreground text-sm h-full overflow-y-auto scrollbar-thin scrollbar-thumb-muted-foreground/20 scrollbar-track-transparent hover:scrollbar-thumb-muted-foreground/40 pr-2" aria-live="polite" tabIndex={0}><q>{testimonial.review}</q></p></div>;
    $[32] = testimonial.review;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== t13 || $[35] !== t14 || $[36] !== t15) {
    t16 = <CardContent className="p-4 h-full flex flex-col">{t13}{t14}{t15}</CardContent>;
    $[34] = t13;
    $[35] = t14;
    $[36] = t15;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  let t17;
  if ($[38] !== t16 || $[39] !== t2) {
    t17 = <Card className={t2}>{t16}</Card>;
    $[38] = t16;
    $[39] = t2;
    $[40] = t17;
  } else {
    t17 = $[40];
  }
  return t17;
};